import React, { useState } from "react";
import { api } from "../../lib/api";
import { Building2 } from "lucide-react";

const FONT = "'Plus Jakarta Sans', sans-serif";
const inp = { width: "100%", padding: "12px 14px", background: "#f4f1e6", border: "1.5px solid #ece9dc", borderRadius: 14, color: "#141414", fontSize: 14, outline: "none", fontFamily: FONT };

// Form masuk Panel Admin — token disimpan ke localStorage "admin_token"
export function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");

  async function login(e) {
    e.preventDefault();
    setMsg("");
    try {
      const j = await api.adminLogin(email, password);
      localStorage.setItem("admin_token", j.token);
      onLogin(j.token);
    } catch (err) { setMsg(err.message); }
  }

  return (
    <div style={{
      minHeight: "100vh", display: "grid", placeItems: "center", fontFamily: FONT,
      background: "radial-gradient(1100px 620px at 15% -5%, #f8f5e8, #efece0 70%)"
    }}>
      <form onSubmit={login} style={{
        background: "#fff", borderRadius: 26, padding: "38px 34px", width: 370,
        boxShadow: "0 18px 50px rgba(20,20,20,0.12)"
      }}>
        <span style={{ width: 40, height: 40, borderRadius: 14, background: "#0000CD", display: "grid", placeItems: "center", marginBottom: 14 }}>
          <Building2 size={19} color="#fff" />
        </span>
        <p style={{ margin: 0, fontSize: 11, letterSpacing: 3, color: "#8a8776", textTransform: "uppercase", fontWeight: 700 }}>Jawsel</p>
        <h1 style={{ margin: "6px 0 4px", fontSize: 26, fontWeight: 800, color: "#141414", letterSpacing: -0.6 }}>Panel Admin</h1>
        <p style={{ margin: "0 0 22px", fontSize: 13, color: "#8a8776" }}>Masuk untuk mengelola kota & walikota</p>
        <input data-testid="admin-email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email"
          style={{ ...inp, marginBottom: 10 }} />
        <input data-testid="admin-password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password"
          style={{ ...inp, marginBottom: 16 }} />
        <button data-testid="admin-login-btn" type="submit"
          style={{ width: "100%", padding: 13, background: "#0000CD", color: "#fff", border: 0, borderRadius: 99, fontWeight: 700, fontSize: 14, transition: "opacity 0.15s", fontFamily: FONT }}
          onMouseEnter={e => e.target.style.opacity = "0.85"} onMouseLeave={e => e.target.style.opacity = "1"}>
          Masuk
        </button>
        {msg && <p data-testid="admin-login-msg" style={{ color: "#dc2626", fontSize: 13, marginTop: 12, marginBottom: 0 }}>{msg}</p>}
      </form>
    </div>
  );
}
